import SaveComparablesButton from "./SaveComparablesButton"

export default function FindComparablesActions({
  data,
  backUrl,
  userCanAddComparables,
  addComparables,
}) {
  function backToSaved() {
    window.Turbo.visit(backUrl)
  }

  return (
    <>
      {userCanAddComparables && (
        <SaveComparablesButton
          comparables={data}
          addComparables={addComparables}
          onBackToSaved={backToSaved}
        />
      )}
    </>
  )
}
